<ng-container *vsLet="claim$ | async as claim">
  <div *ngIf="item$ | async as item" class="flex flex-col gap-4">
    <p class="font-medium text-gray-500 mb-2">Cure Details</p>

    <ws-claim-item-cure-card class="border rounded-xl" [item]="item"></ws-claim-item-cure-card>

    <div *vsLet="isCustomerPortal$ | async as isCustomerPortal">
      <ng-container *vsLet="canAdjudicateClaimItem$ | async as canAdjudicateClaimItem">
        <div
          *vsLet="canManageCure$ | async as canManageCure"
          class="flex gap-2"
          [class.justify-end]="claim?.status !== open || item.authorizationId || !canManageCure || item.deleted"
          [class.justify-between]="claim?.status === open && !item.authorizationId && canManageCure && !item.deleted"
        >
          <button
            *ngIf="
              !isCustomerPortal && canManageCure && claim?.status === open && !item.authorizationId && !item.deleted
            "
            vs-button
            appearance="outline"
            (click)="navigateTo('manage-cure')"
          >
            Edit
          </button>

          <div class="flex gap-2">
            <button vs-button appearance="outline" (click)="navigateTo('', item)">Back</button>

            <!-- Wrapped: a disabled button gets no hover, so the tooltip sits on the wrapper -->
            <div
              *vsLet="nextBlockedReason(claim, item, !!canAdjudicateClaimItem) as reason"
              tooltipStyle="light"
              [vsTooltip]="!isCustomerPortal && reason ? reason : ''"
            >
              <button
                vs-button
                theme="primary"
                [disabled]="!!reason"
                (click)="
                  isCustomerPortal
                    ? navigateTo('resolve')
                    : item.adjudicationReason || item.deleted || claim?.status !== open
                      ? navigateTo('adjudicate')
                      : navigateTo('manage-adjudication')
                "
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
